enum Fonts {
  Pixel = "pixel",
}

export default Fonts;
